/* src/app/components/ai-assist/ai-assist.component.scss */
:host {
  height: 100vh;
}
.document-header {
  width: 100%;
  position: relative;
  z-index: 10;
}
.document-header__wrapper {
  width: 100%;
}
.document-header__top {
  min-height: 64px;
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
}
.back-button {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 0;
  background: transparent;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.back-button i {
  font-size: 18px;
}
.back-button:hover {
  background: #f1f5f9;
  color: #253b80;
}
.back-button:active {
  transform: translateY(1px);
}
.document-info {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
.document-title {
  min-width: 0;
  max-width: 360px;
  display: flex;
  align-items: center;
  gap: 9px;
  color: #1e293b;
  font-size: 15px;
  font-weight: 650;
  white-space: nowrap;
}
.document-title__icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #eef2ff;
  color: #253b80;
  font-size: 15px;
}
.document-title span {
  overflow: hidden;
  text-overflow: ellipsis;
}
.query-switch {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  border-radius: 10px;
}
.query-option {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  padding: 5px 12px;
  border-radius: 7px;
  cursor: pointer;
  color: #64748b;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;
}
.query-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.query-option:hover {
  color: #253b80;
}
.query-option.active {
  background: #253b80;
  color: #fff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
}
.query-option.active .query-radio {
  border-color: #fff;
}
.query-option.active .query-radio::after {
  transform: scale(1);
  opacity: 1;
}
.query-radio {
  width: 15px;
  height: 15px;
  flex: 0 0 15px;
  border: 2px solid #94a3b8;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s ease;
}
.query-radio::after {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #253b80;
  transform: scale(0);
  opacity: 0;
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.query-content {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}
.query-label {
  font-size: 13px;
  font-weight: 650;
}
.query-description {
  margin-top: 2px;
  font-size: 10px;
  font-weight: 400;
  color: #94a3b8;
}
.header-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  border-radius: 10px;
}
.header-action {
  position: relative;
  min-width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.header-action i {
  font-size: 17px;
}
.header-action span {
  display: none;
  font-size: 12px;
  font-weight: 600;
}
.header-action:hover {
  background: #f1f5f9;
  color: #253b80;
}
.header-action.active {
  background: #eef2ff;
  color: #253b80;
}
.header-action[data-tooltip]::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: -38px;
  left: 50%;
  transform: translateX(-50%) translateY(-3px);
  padding: 6px 9px;
  border-radius: 6px;
  background: #1e293b;
  color: #ffffff;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease, transform 0.15s ease;
  z-index: 100;
}
.header-action[data-tooltip]:hover::after {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}
.mobile-query-switch {
  display: none;
}
@media (min-width: 1200px) {
  .header-action span {
    display: inline;
  }
  .header-action {
    min-width: auto;
    padding: 0 12px;
  }
}
@media (max-width: 1199px) {
  .document-header__wrapper {
    padding: 0 16px;
  }
  .document-header__top {
    gap: 12px;
  }
  .document-info {
    gap: 14px;
  }
  .document-title {
    max-width: 280px;
  }
  .query-description {
    display: none;
  }
}
@media (max-width: 767px) {
  .document-header__wrapper {
    padding: 0 12px;
  }
  .document-header__top {
    min-height: 58px;
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 8px;
  }
  .back-button {
    padding: 7px;
  }
  .back-button .desktop-only {
    display: none;
  }
  .back-button i {
    font-size: 20px;
  }
  .mobile-only {
    display: inline;
  }
  .document-info {
    min-width: 0;
    display: block;
  }
  .document-title {
    max-width: 100%;
    font-size: 13px;
    justify-content: center;
  }
  .document-title__icon {
    width: 28px;
    height: 28px;
    font-size: 13px;
  }
  .header-actions {
    gap: 2px;
    padding: 3px;
  }
  .header-action {
    width: 36px;
    min-width: 36px;
    height: 36px;
  }
  .header-action i {
    font-size: 15px;
  }
  .header-action span {
    display: none;
  }
  .header-action[data-tooltip]::after {
    display: none;
  }
  .mobile-query-switch {
    display: flex;
    justify-content: center;
    padding: 0 0 10px;
  }
  .mobile-query-switch .query-switch {
    width: 100%;
    max-width: 280px;
    justify-content: center;
  }
  .mobile-query-switch .query-option {
    flex: 1;
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .document-header__top {
    grid-template-columns: auto minmax(0, 1fr) auto;
  }
  .document-title__icon {
    display: none;
  }
  .document-title span {
    max-width: 150px;
    text-align: center;
  }
  .header-actions {
    border: 0;
    background: transparent;
  }
  .header-action {
    width: 34px;
    min-width: 34px;
    height: 34px;
  }
}
#botWrapper {
  display: flex;
  width: 100%;
  position: relative;
  justify-content: center;
  padding: 0px 5px;
}
::ng-deep body {
  overflow-y: hidden !important;
}
.second-level-menu {
  background: transparent !important;
  min-width: auto !important;
  max-width: 350px !important;
}
header {
  border-left: 0px !important;
  height: auto !important;
}
.chat-header {
  height: auto;
  justify-content: center;
  margin-top: 10px;
  position: relative;
  display: flex;
}
.chat-header,
.chat-content {
  width: 100%;
  display: flex;
  margin: 10px auto;
}
#botinput-wrapper ul.dropdown-menu,
#chat-list-content ul.dropdown-menu {
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
}
#botinput-wrapper ul.dropdown-menu li,
#chat-list-content ul.dropdown-menu li {
  display: flex;
  align-items: center;
  padding-left: 10px;
  color: #666;
  height: 30px;
  cursor: pointer;
}
#botinput-wrapper ul.dropdown-menu li:hover,
#chat-list-content ul.dropdown-menu li:hover {
  background: #f1f1f1;
}
#chat-list-content ul.dropdown-menu li {
  gap: 10px;
}
.chat-content {
  width: 90%;
  justify-content: space-evenly;
}
.wrapper {
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: stretch;
}
.chat-sidebar {
  max-width: 320px;
  height: 100%;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;
}
.chatBotstyle {
  display: flex;
  flex-direction: row;
  width: 100% !important;
  height: 100%;
}
.hide {
  display: none;
}
.fa {
  cursor: pointer;
}
.chat-box-wrapper {
  position: relative;
  display: flexbox;
  width: 90%;
}
.chat-left-content {
  background: #fff;
  min-width: 280px;
  overflow-y: auto;
}
.chat-right-content {
  min-width: 70%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: space-evenly;
}
#title {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-evenly;
  margin: 10px 0px;
  font-size: 16px;
  font-weight: bold;
}
.chat-history-list {
  height: 100vh;
  width: 100%;
  margin-left: 0px;
  position: absolute;
  z-index: 9;
  right: 0px;
  top: 0px;
}
.chat-history-list .left-box-shadow {
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
}
.chat-history-list .listing-data {
  height: 90vh;
  overflow-y: auto;
  background: #fff;
  padding-bottom: 1.5em;
  padding-left: 0.5rem;
}
.chat-history-list .listing-data.templatesection {
  height: 100vh;
}
.chat-history-list .audio-wrapper {
  position: absolute;
  z-index: 999;
  right: -2rem;
  background: rgba(0, 0, 0, 0.5);
}
.chat-history-list .audio-wrapper.is-active {
  display: block;
}
select {
  appearance: base-select;
  color: var(--textsecondarycolor) !important;
  background-color: transparent;
  width: 180px;
  height: 2rem;
  font-size: 1rem;
  box-sizing: border-box;
  padding: 0.5rem 0.75rem;
  border: 1px solid #a7a7a7;
  border-radius: calc(0.5rem - 2px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
select > button {
  display: flex;
  width: 100%;
  font-family: inherit;
  color: currentColor;
}
select > button > svg {
  margin: 0 0 0 auto;
  width: 1.2rem;
  height: 1.2rem;
}
select:has(option:not([hidden]):checked) {
  color: var(--textsecondarycolor);
}
select:focus-visible {
  outline: 2px solid #a1a1aa;
  outline-offset: -1px;
}
select::picker-icon {
  display: none;
}
select::picker(select) {
  appearance: base-select;
  border: 1px solid #e4e4e7;
  padding: 0.25rem;
  margin-top: 0.25rem;
  border-radius: calc(0.5rem - 2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  cursor: default;
  transition: opacity 225ms ease-in-out, transform 225ms ease-in-out;
  transform-origin: top;
  transform: translateY(0);
  opacity: 1;
}
@starting-style {
  select::picker(select) {
    transform: translateY(-0.25rem) scale(0.95);
    opacity: 0;
  }
}
select optgroup label {
  display: block;
  padding: 0.375rem 0.5rem;
}
select option {
  padding: 0.375rem 0.5rem;
  border-radius: calc(0.5rem - 4px);
  outline: none;
}
select option::after {
  content: "";
  width: 1rem;
  height: 1.5rem;
  margin-left: auto;
  opacity: 0;
}
select option::checkmark {
  display: none;
}
select option:checked {
  background-color: #f4f4f5;
}
select option:checked::after {
  opacity: 1;
}
select option:hover,
select option:focus-visible {
  background-color: #f4f4f5;
  color: var(--textsecondarycolor);
}
.select:not(.is-multiple):not(.is-loading)::after {
  right: 1.5em;
  z-index: 4;
  top: 15px;
  font-size: 1rem;
}
::ng-deep .audio-file-class {
  width: 100%;
  min-width: 300px;
}
.chat-history-list ul {
  margin: 10px 0px;
  padding: 0px 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  line-height: 1.2rem;
}
.chat-history-list ul li {
  display: inline-flex;
  justify-content: space-evenly;
  align-items: baseline;
  border-bottom: 1px solid var(--bodyBgColor) !important;
  color: #000 !important;
}
.chat-history-list ul li label:first-child {
  display: inline-block;
  border-radius: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  font-size: 0.9rem;
  min-height: 25px;
  padding: 10px 10px;
  margin-bottom: 10px;
  width: 90%;
}
.chat-history-list ul li label:last-child {
  margin: 0% 3%;
  display: inline-block;
  width: 5%;
  padding-left: 2%;
}
#chat-list-content {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  max-width: 960px;
  font-size: 0.9rem !important;
  max-height: 66vh;
  min-height: 66vh;
  overflow-y: auto;
  scrollbar-width: none;
}
#chat-list {
  width: 100%;
  display: inline-block;
  margin-left: 0rem;
  padding-bottom: 5%;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
#chat-list::-webkit-scrollbar {
  display: none;
}
.chat-list-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 960px;
}
#chat-message-enter-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 1rem;
  z-index: 1;
  border: 1px solid rgba(116, 113, 113, 0.5098039216);
}
@media screen and (max-width: 767px) {
  #chat-message-enter-box {
    border-radius: 1.5rem;
    padding: 5px;
  }
}
#chat-message-enter-box form {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}
@media screen and (max-width: 767px) {
  #chat-message-enter-box form {
    padding: 5px;
  }
}
#chat-message-enter-box textarea {
  width: 100% !important;
  border: none;
  padding: 10px;
  color: #666;
  font-size: 1em;
  resize: none;
  height: 55px;
}
@media screen and (max-width: 767px) {
  #chat-message-enter-box textarea {
    padding: 8px;
    font-size: 0.9rem;
    height: 50px;
  }
}
@media screen and (max-width: 480px) {
  #chat-message-enter-box textarea {
    padding: 6px;
    font-size: 0.85rem;
    height: 45px;
  }
}
#chat-message-enter-box span {
  display: inline-block;
  color: #666;
  width: 100% !important;
  padding: 10px;
  color: #666;
  font-size: 1em;
  min-height: 40px;
}
@media screen and (max-width: 767px) {
  #chat-message-enter-box span {
    padding: 8px;
    font-size: 0.9rem;
    min-height: 35px;
  }
}
@media screen and (max-width: 480px) {
  #chat-message-enter-box span {
    padding: 6px;
    font-size: 0.85rem;
    min-height: 30px;
  }
}
.fa-cloud,
.fa-user-circle {
  color: #9da0a3;
  margin-top: 5px;
  font-size: 30px !important;
}
app-toggle-icon::ng-deep .fa-microphone-slash,
.fa-microphone-slash {
  opacity: 0.5 !important;
}
textarea::placeholder {
  color: rgb(182, 182, 182) !important;
}
.question {
  background: #848a92;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #fff;
  margin-bottom: 10px;
  width: 100%;
  margin-left: 20px;
  position: relative;
}
.question::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #848a92 transparent transparent transparent;
}
.question.align-right {
  background: #9da0a3;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #fff;
  margin-bottom: 10px;
  width: 100%;
  margin-left: 50%;
  margin-right: 15px;
  position: relative;
}
.question.align-right::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -20px;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #848a92 transparent transparent transparent;
}
video {
  margin: 10px 0px;
}
.answer {
  background: #fff;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #666;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 19px;
}
.answer .answer-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 10px;
  gap: 15px;
}
.answer .audio {
  cursor: pointer;
}
.answer .menu-list {
  position: relative;
}
.answer .menu-list ul {
  position: absolute;
  top: -10px;
  right: 0px;
  width: max-content;
}
.answer .menu-list ul li {
  margin: 10px 10px !important;
  display: inline-block;
  cursor: pointer;
}
.answer .menu-list ul li:hover .fa {
  color: #008cb3;
}
.answer .menu-list ul.active {
  display: block;
}
.answer .menu-list label {
  width: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.answer .menu-list::-webkit-scrollbar {
  width: 6px;
}
.answer .menu-list::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 4px;
}
.answer .menu-list::-webkit-scrollbar-thumb:hover {
  background: #888;
}
.answer-content::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -32px;
  right: auto;
  top: -35px;
  bottom: auto;
  border: 21px solid;
  border-color: #fff transparent transparent transparent;
}
.answer-content {
  position: relative;
  margin-top: 25px;
}
.answer-content ol {
  padding: 30px;
}
.chat-icon {
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background: #d2daf3;
}
.chat-icon img {
  border-radius: 100%;
}
.username {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background: #d2daf3;
  color: #133aa5;
  vertical-align: middle;
  text-align: center;
  font-size: 22px;
  margin-right: 5px;
  display: inline-block;
  text-transform: uppercase;
}
#chatForm {
  width: 98%;
  height: inherit;
}
#chatForm > span {
  width: 90%;
  height: inherit;
  margin-left: 10px;
}
#expand-collapse {
  position: relative;
  margin-top: 25px;
  height: 15px;
}
#expand-collapse i {
  background: #fff;
  padding: 7px;
}
#expand-collapse .fa {
  font-size: 1.5em !important;
  transform: rotate(180deg) translateX(0px);
  transform-origin: 50% 20%;
}
#expand-collapse-right {
  position: relative;
  height: 15px;
}
#expand-collapse-right i {
  background: #fff;
  padding: 7px;
}
#expand-collapse-right .fa {
  font-size: 1.5em !important;
  transform: rotate(0deg) translateX(0px);
  transform-origin: 50% 20%;
}
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-track {
  background: #fff;
}
::-webkit-scrollbar-thumb {
  background: #fff;
}
::-webkit-scrollbar-thumb:hover {
  background: #fff;
}
#chat-content-wrapper header {
  background: transparent !important;
  padding: 5px !important;
}
@media screen and (max-width: 768px) {
  #botWrapper {
    width: 70%;
  }
  #chat-content-wrapper {
    width: 100%;
  }
  .bot-middle-content {
    padding: 0;
  }
}
#voice-message {
  width: 80% !important;
  position: relative;
  margin-top: -40px;
  margin-left: 10px;
  padding-right: 10px;
  height: 40px;
}
#voice-message span {
  display: inline-block;
  color: #4d4d4d;
}
#chat-tools-wrapper {
  display: flex;
  width: 100%;
  justify-content: end;
  padding: 10px;
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
  background: rgba(204, 204, 204, 0.1803921569);
}
@media screen and (max-width: 767px) {
  #chat-tools-wrapper {
    justify-content: center;
    padding: 8px;
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
}
#chat-tools {
  display: flex;
  list-style-type: none;
  width: auto;
  flex-direction: row;
  gap: 20px;
  padding: 0px;
  margin: 0px;
  position: relative;
  right: 10px;
}
#chat-tools li {
  display: flex;
  align-items: center;
}
#chat-tools .pi-send {
  transform: rotate(45deg);
}
#chat-tools .pi,
#chat-tools .fa {
  font-size: 1.2rem !important;
}
#chat-tools li.selected-docs-menu {
  position: relative;
}
#chat-tools li.selected-docs-menu .hover-menu {
  display: none;
  position: absolute;
  right: 0;
  top: 28px;
  min-width: 220px;
  max-width: 420px;
  max-height: 260px;
  overflow-y: auto;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 8px 0;
  z-index: 1000;
}
#chat-tools li.selected-docs-menu:hover .hover-menu {
  display: block;
}
#chat-tools li.selected-docs-menu .hover-menu .menu-header {
  font-weight: 600;
  font-size: 0.85rem;
  padding: 6px 12px 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  color: #333;
}
#chat-tools li.selected-docs-menu .hover-menu .menu-list {
  list-style: none;
  margin: 0;
  padding: 6px 0;
}
#chat-tools li.selected-docs-menu .hover-menu .menu-list li {
  font-size: 0.85rem;
  color: #444;
  padding: 6px 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 380px;
}
#chat-tools li.selected-docs-menu .hover-menu .menu-list li:hover {
  background: #f7f7f7;
}
#chat-tools .switch {
  position: relative;
  display: inline-block;
  width: 35px;
  height: 20px;
}
#chat-tools .switch span {
  min-height: 20px;
}
#chat-tools .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
#chat-tools .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
#chat-tools .slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
#chat-tools input:checked + .slider {
  background-color: var(--primaryColor);
}
#chat-tools input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
#chat-tools input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}
#chat-tools {
}
#chat-tools .slider.round {
  border-radius: 34px;
}
#chat-tools .slider.round:before {
  border-radius: 50%;
}
[hidden] {
  display: none !important;
}
.comment-area-box::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 1px;
  left: 99%;
  box-sizing: border-box;
  border: 10px solid rgba(0, 0, 0, 0.5);
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);
}
.comment-area-box {
  position: absolute;
  z-index: 999;
  top: 40px;
  right: 0px;
  display: none;
  background: #fff;
  padding: 20px 40px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;
  width: 300px;
}
.comment-area-box label {
  width: fit-content !important;
}
.comment-area-box textarea {
  resize: none;
}
.comment-area-box .form-btns {
  width: 100%;
  display: flex;
  margin: 10px 0px;
}
.comment-area-box .form-btns .btn:first-child {
  border: 1px solid #dbdbdb;
  background: #fff !important;
  color: #000 !important;
}
.comment-area-box .form-btns .btn {
  --bs-btn-line-height: 1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: #133aa5;
  margin-right: 15px;
  border: none;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
}
.comment-area-box.is-active {
  display: block;
}
.dropdown-list {
  display: block;
  border-radius: 5px;
  display: block;
  height: 30px;
  padding: 5px;
  border: 1px solid gray;
}
.dropdown-list.show {
  display: block;
}
.toggle-button {
  display: block;
  margin-bottom: 10px;
}
#right-side-panel {
  width: 20%;
  background: #fff;
  box-shadow: 0px 0px 4px #b2b2b2;
  padding: 10px;
}
#designlist {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px;
}
#designlist label {
  font-size: 14px;
  font-weight: bold;
}
#designlist li {
  list-style: none;
  margin: 10px;
  white-space: nowrap;
  border: 1px solid #dcd8d8;
  color: #222222;
  cursor: pointer;
  width: 100%;
  height: 100px;
  overflow: hidden;
}
#designlist li.active {
  border: 2px dashed var(--primaryColor);
}
@media screen and (min-width: 768px) {
  .toggle-button {
    display: none;
  }
  .mobile-close-btn {
    display: none;
  }
}
.dropdown-trigger {
  display: flex;
  position: relative;
  right: 0px;
  justify-content: end;
  align-items: end;
  text-align: end;
  width: 32px;
}
.select-container {
  padding: 10px;
}
@media screen and (max-width: 640px) {
  #chat-content-wrapper.hide {
    display: none;
  }
  .chat-history-list {
    width: auto;
  }
  .tabs-container.vertical .tab-content.active {
    width: calc(100% - 20px);
  }
  app-page-header .page-title {
    font-size: 0.9rem;
  }
  app-page-header .page-title .icon {
    font-size: 0.85rem;
  }
  app-page-header .pull-right > span:first-child {
    font-size: 0.75rem !important;
  }
  app-page-header .pull-right .radio-group .radio {
    min-width: 80px;
    margin: 0.15rem;
  }
  app-page-header .pull-right .radio-group .radio label {
    font-size: 0.75rem !important;
  }
  #chat-tools-wrapper #chat-tools {
    gap: 8px;
  }
  #chat-tools-wrapper #chat-tools li {
    font-size: 0.9rem !important;
  }
  .right-sidebar .tab-list li {
    width: 45px !important;
    padding: 8px 5px !important;
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) {
  audio {
    width: 100% !important;
    max-width: 300px;
  }
  #expand-collapse {
    visibility: visible;
  }
  .select-container {
    padding: 0px 20px;
    position: absolute;
    right: 20px;
    top: 70px;
    background: #fff;
    justify-content: center;
    align-items: center;
    height: 21vh;
    min-width: 148px;
  }
  .dropdown-list {
    margin: 10px;
  }
  .mobile-close-btn {
    display: block;
  }
  .hidemobileView {
    display: none;
  }
  #botWrapper.rightpanel-active #chat-content-wrapper {
    display: none !important;
  }
  #botWrapper.rightpanel-active #right-side-panel {
    width: 100%;
  }
  #botWrapper.leftpanel-active #chat-content-wrapper {
    display: none !important;
  }
  #botinput-wrapper {
    width: 100% !important;
    padding: 0 5px;
  }
  .chat-header {
    width: 100% !important;
    justify-content: center;
    padding: 0 5px;
  }
  #chat-list-content {
    padding: 1% 0%;
    width: 100%;
    margin-left: 0%;
    max-width: 100%;
  }
  #chat-list {
    width: 100%;
    padding: 0 5px;
  }
  #chat-content-wrapper header {
    padding: 0px 5px !important;
  }
  #designlist li {
    height: 150px !important;
  }
  .mobileBased-header-section {
    flex-direction: column;
    gap: 10px;
    padding: 10px;
  }
  .mobileBased-header-section .page-title {
    width: 100%;
  }
  .mobileBased-header-section .page-title .icon {
    font-size: 0.9rem;
    padding: 5px 0;
  }
  .mobileBased-header-section .pull-right {
    width: 100% !important;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .tab-list li {
    min-width: 44px;
    min-height: 44px;
    padding: 10px;
  }
  #chat-message-enter-box {
    width: 100%;
    margin: 0 auto;
  }
  #chat-message-enter-box #chatForm {
    width: 100%;
  }
  #voice-message {
    width: 100% !important;
    margin-left: 0;
    padding: 5px 10px;
    font-size: 0.85rem;
  }
  app-page-header .pull-right {
    width: 100% !important;
    flex-direction: column;
    align-items: flex-start !important;
    gap: 10px;
    margin-top: 10px;
  }
  app-page-header .pull-right.mobile-header-section {
    width: 100% !important;
    flex-direction: column;
    align-items: flex-start !important;
  }
  app-page-header .pull-right > span {
    width: 100% !important;
    margin: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  app-page-header .pull-right > span.mobile-doc-title {
    margin: 0 !important;
    flex-direction: column;
    gap: 10px;
  }
  app-page-header .pull-right > span:first-child {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.85rem;
  }
  app-page-header .pull-right > span .mobile-title-text {
    white-space: normal !important;
    word-break: break-word;
    max-width: 100%;
  }
  app-page-header .pull-right .radio-group {
    width: 100% !important;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
  }
  app-page-header .pull-right .radio-group.mobile-radio-group {
    flex-direction: column;
    width: 100% !important;
  }
  app-page-header .pull-right .radio-group .radio {
    margin: 0.25rem;
    flex: 1;
    min-width: 100px;
  }
  app-page-header .pull-right .radio-group .radio label {
    font-size: 0.85rem;
    white-space: nowrap;
  }
  app-page-header .right-menu .tab-list {
    gap: 0px !important;
    flex-wrap: wrap;
  }
  app-page-header .right-menu .tab-list li {
    width: 35px !important;
    padding: 8px 5px !important;
    font-size: 0.9rem;
  }
  app-page-header .right-menu .tab-list li::before {
    content: none;
  }
  #botWrapper {
    padding: 0px 5px;
  }
  .bot-middle-content {
    min-width: 100% !important;
    width: 100%;
    padding: 0 5px;
  }
  #chat-message-enter-box {
    border-radius: 1rem;
    padding: 8px;
  }
  #chat-message-enter-box #chatForm {
    width: 100%;
  }
  #chat-tools-wrapper {
    padding: 8px 5px;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
  }
  #chat-tools-wrapper #chat-tools {
    gap: 10px;
    right: 0;
    flex-wrap: wrap;
    justify-content: center;
  }
  #chat-tools-wrapper #chat-tools li {
    font-size: 1rem !important;
  }
  #chat-tools-wrapper #chat-tools .category-dropdown-wrapper {
    width: 100%;
    order: -1;
  }
  #chat-tools-wrapper #chat-tools .category-dropdown-wrapper ::ng-deep .p-dropdown {
    width: 100% !important;
    min-width: 100% !important;
  }
  .right-sidebar {
    right: -100%;
  }
  .right-sidebar.open {
    right: 0;
  }
  .right-sidebar .tab-list {
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px 5px;
  }
  .right-sidebar .tab-list li {
    width: 50px !important;
    padding: 10px;
  }
  .right-sidebar .tab-content .tab-view .listing-data {
    padding-left: 0.25rem;
  }
  .ai-assist-popup .container {
    padding: 0.5rem;
  }
  .ai-assist-popup .row {
    flex-direction: column;
  }
  .ai-assist-popup .row .col-8,
  .ai-assist-popup .row .col-4 {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0.5rem;
  }
  .ai-assist-popup .row .col-8 {
    order: 2;
  }
  .ai-assist-popup .row .col-4 {
    order: 1;
  }
  .ai-assist-popup .card {
    height: auto !important;
    max-height: calc(100vh - 100px);
  }
  .ai-assist-popup .pop-content {
    height: calc(100vh - 300px) !important;
    max-height: 400px;
  }
  .ai-assist-popup .list-wrapper.list-overflow {
    height: calc(100vh - 200px) !important;
    max-height: 300px;
  }
  .policy-upload .modal-dialog {
    margin: 10px auto;
    max-width: 600px;
    max-height: 90vh;
    display: flex;
    align-items: center;
    min-height: 0;
  }
  .policy-upload .modal-dialog .modal-content {
    max-width: 100%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .policy-upload .modal-dialog .modal-header {
    flex-shrink: 0;
  }
  .policy-upload .modal-dialog .modal-body {
    max-height: calc(90vh - 120px);
    padding: 15px;
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    min-height: 0;
  }
  .policy-upload .modal-dialog .modal-footer {
    flex-shrink: 0;
  }
  .policy-upload .row .col-5,
  .policy-upload .row .col-6,
  .policy-upload .row .col-7 {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0.5rem 0;
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) and (max-width: 768px) {
  .policy-upload .modal-dialog {
    margin: 10px;
    max-width: calc(100% - 20px);
    max-height: 95vh;
  }
  .policy-upload .modal-dialog .modal-content {
    max-height: 95vh;
  }
  .policy-upload .modal-dialog .modal-body {
    max-height: calc(95vh - 120px);
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) {
  p.disclaimer {
    font-size: 0.7rem !important;
    padding: 5px !important;
  }
  p.disclaimer span {
    font-size: 0.7rem !important;
  }
  p.disclaimer span ::ng-deep b {
    font-size: 0.75rem !important;
  }
  #chat-list-content {
    max-height: calc(100vh - 250px) !important;
    min-height: calc(100vh - 250px) !important;
    padding: 0 5px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .question {
    margin-left: 5px !important;
    margin-right: 5px !important;
    padding: 10px !important;
    font-size: 0.9rem !important;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .question::before {
    left: -15px !important;
    border-width: 15px !important;
  }
  .answer {
    margin-left: 5px !important;
    margin-right: 5px !important;
    padding: 10px !important;
    font-size: 0.9rem !important;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .answer .answer-content::before {
    left: -25px !important;
    border-width: 15px !important;
  }
  #botWrapper {
    padding: 0;
  }
  .right-sidebar {
    width: 100% !important;
    max-width: 100%;
  }
  .right-sidebar .tab-content {
    padding: 10px 5px;
  }
  .right-sidebar .listing-data {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .ai-assist-popup .container {
    padding: 0.5rem;
  }
  .ai-assist-popup .row {
    margin: 0;
  }
  .ai-assist-popup .col-8,
  .ai-assist-popup .col-4 {
    padding: 0.5rem;
  }
  .policy-upload .modal-dialog {
    margin: 10px;
    max-width: calc(100% - 20px);
  }
  .policy-upload .modal-body {
    padding: 15px 10px;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }
  #chat-tools-wrapper {
    padding: 8px;
    flex-wrap: wrap;
  }
  #chat-tools-wrapper #chat-tools {
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
  }
  #chat-tools-wrapper #chat-tools li {
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media screen and (max-width: 480px) {
  app-page-header .pull-right .radio-group {
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }
  app-page-header .pull-right .radio-group .radio {
    width: 100%;
    min-width: 100%;
    margin: 0.25rem 0;
  }
  app-page-header .pull-right .radio-group .radio label {
    font-size: 0.8rem;
    padding: 8px;
  }
  app-page-header .right-menu .tab-list {
    width: 100%;
    justify-content: space-around;
    gap: 5px;
  }
  app-page-header .right-menu .tab-list li {
    flex: 1;
    max-width: 60px;
    min-width: 44px;
    min-height: 44px;
  }
  app-page-header .page-title {
    font-size: 0.85rem;
  }
  app-page-header .page-title .icon {
    font-size: 0.8rem;
  }
  #chat-tools-wrapper {
    padding: 5px;
  }
  #chat-tools-wrapper #chat-tools {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
  }
  #chat-tools-wrapper #chat-tools .category-dropdown-wrapper {
    width: 100%;
    order: -1;
    margin-bottom: 5px;
  }
  #chat-tools-wrapper #chat-tools .category-dropdown-wrapper ::ng-deep .p-dropdown {
    width: 100% !important;
  }
  #chat-tools-wrapper #chat-tools li {
    min-width: 44px;
    min-height: 44px;
    flex: 0 0 auto;
    justify-content: center;
    padding: 8px;
  }
  .ai-assist-popup {
    padding: 0.5rem;
  }
  .ai-assist-popup .pop-content {
    height: calc(100vh - 280px) !important;
    max-height: 300px;
    padding: 10px;
    font-size: 0.85rem;
  }
  .ai-assist-popup .list-wrapper.list-overflow {
    height: calc(100vh - 180px) !important;
    max-height: 250px;
  }
  .ai-assist-popup .pop-header {
    padding: 10px !important;
    font-size: 0.9rem;
  }
  .ai-assist-popup .card-content {
    padding: 10px !important;
  }
  .policy-upload .modal-dialog {
    margin: 5px;
    max-width: calc(100% - 10px);
  }
  .policy-upload .modal-body {
    padding: 10px 5px;
    font-size: 0.85rem;
  }
  .policy-upload .modal-footer {
    padding: 10px;
    flex-direction: column;
    gap: 8px;
  }
  .policy-upload .modal-footer button {
    width: 100%;
    margin: 0;
  }
  .question,
  .answer {
    margin-left: 5px !important;
    margin-right: 5px !important;
    padding: 8px !important;
    font-size: 0.85rem !important;
    line-height: 1.4;
  }
  #chat-list-content {
    max-height: calc(100vh - 280px) !important;
    min-height: calc(100vh - 280px) !important;
  }
  #chat-message-enter-box {
    border-radius: 1.5rem;
    padding: 5px;
  }
  #chat-message-enter-box #chatForm {
    padding: 5px;
  }
  p.disclaimer {
    font-size: 0.65rem !important;
    padding: 5px !important;
    line-height: 1.3;
  }
  .right-sidebar .tab-list {
    padding: 5px;
  }
  .right-sidebar .tab-list li {
    padding: 8px 5px;
    font-size: 0.9rem;
  }
  .history-item,
  .pin-item,
  .file-item,
  .audio-item {
    padding: 10px 5px;
    font-size: 0.85rem;
  }
  .audio-wrapper {
    width: 100% !important;
    max-width: 100%;
    right: 0;
    left: 0;
    padding: 10px;
  }
  .audio-wrapper audio {
    width: 100% !important;
  }
}
@media screen and (min-width: 641px) and (max-width: 960px) {
  .bot-middle-content {
    min-width: 100% !important;
    max-width: 100%;
    padding: 0 15px;
  }
  #chat-list-content {
    max-width: 100%;
    padding: 0 10px;
    max-height: calc(100vh - 200px) !important;
    min-height: calc(100vh - 200px) !important;
  }
  app-page-header .pull-right {
    width: auto !important;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }
  app-page-header .pull-right > span {
    width: auto !important;
  }
  app-page-header .pull-right .radio-group {
    width: auto !important;
    flex-wrap: wrap;
  }
  .ai-assist-popup .row {
    flex-direction: row;
  }
  .ai-assist-popup .row .col-8 {
    width: 60% !important;
  }
  .ai-assist-popup .row .col-4 {
    width: 40% !important;
  }
  #chat-message-enter-box {
    width: 100%;
    padding: 10px;
  }
  #chat-tools-wrapper {
    padding: 10px;
  }
  #chat-tools-wrapper #chat-tools {
    gap: 15px;
  }
  .question,
  .answer {
    margin-left: 15px;
    padding: 12px;
    font-size: 0.95rem;
  }
}
#botinput-wrapper {
  width: 97%;
}
#botinput-wrapper p.disclaimer {
  color: var(--textsecondarycolor) !important;
  padding: 0px;
  margin-top: 6px;
}
#botinput-wrapper p.disclaimer span {
  display: inline-block;
  text-align: center;
  color: var(--textsecondarycolor) !important;
}
#botinput-wrapper p.disclaimer span ::ng-deep b {
  font-size: 0.9rem !important;
}
#botinput-wrapper p.disclaimer span span {
  font-size: 0.75rem;
}
#botinput-wrapper p.disclaimer .expan-down-arrow {
  display: flex;
  justify-content: center;
}
#botinput-wrapper p.disclaimer .expan-down-arrow a {
  background-color: #fff;
  padding: 7px;
}
#botinput-wrapper p.disclaimer .expan-down-arrow a .fa {
  font-size: 1.5rem !important;
}
.bot-middle-content {
  width: 100%;
  max-width: 960px;
  margin: auto;
  min-width: 840px;
}
@media screen and (max-width: 840px) {
  .bot-middle-content {
    min-width: 100%;
    padding: 0 10px;
  }
}
#template-title {
  display: inline-flex;
  width: 100%;
  font-size: 1rem;
}
#template-title span:nth-child(1) {
  width: 80%;
  text-align: center;
}
#template-title span:nth-child(2) {
  width: 20%;
}
#template-title .button {
  border-color: #fff;
  border-width: 0px;
}
#designlist-wrapper {
  height: 90vh;
  overflow-y: auto;
  padding: 0px 20px;
}
@media screen and (max-width: 640px) {
  .chat-history-list {
    left: 0px;
    top: 0px;
  }
}
@media screen and (min-width: 768px) and (max-width: 960px) {
  #chat-list-content {
    padding: 1% 3% 0% 1% !important;
  }
}
.checkbox-wrapper .tgl {
  display: none;
}
.checkbox-wrapper .tgl,
.checkbox-wrapper .tgl:after,
.checkbox-wrapper .tgl:before,
.checkbox-wrapper .tgl *,
.checkbox-wrapper .tgl *:after,
.checkbox-wrapper .tgl *:before,
.checkbox-wrapper .tgl + .tgl-btn {
  box-sizing: border-box;
}
.checkbox-wrapper .tgl::-moz-selection,
.checkbox-wrapper .tgl:after::-moz-selection,
.checkbox-wrapper .tgl:before::-moz-selection,
.checkbox-wrapper .tgl *::-moz-selection,
.checkbox-wrapper .tgl *:after::-moz-selection,
.checkbox-wrapper .tgl *:before::-moz-selection,
.checkbox-wrapper .tgl + .tgl-btn::-moz-selection,
.checkbox-wrapper .tgl::selection,
.checkbox-wrapper .tgl:after::selection,
.checkbox-wrapper .tgl:before::selection,
.checkbox-wrapper .tgl *::selection,
.checkbox-wrapper .tgl *:after::selection,
.checkbox-wrapper .tgl *:before::selection,
.checkbox-wrapper .tgl + .tgl-btn::selection {
  background: none;
}
.checkbox-wrapper .tgl + .tgl-btn {
  outline: 0;
  display: block;
  width: 2.7em;
  height: 1.4em;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbox-wrapper .tgl + .tgl-btn:after,
.checkbox-wrapper .tgl + .tgl-btn:before {
  position: relative;
  display: block;
  content: "";
  width: 50%;
  height: 100%;
}
.checkbox-wrapper .tgl + .tgl-btn:after {
  left: 0;
}
.checkbox-wrapper .tgl + .tgl-btn:before {
  display: none;
}
.checkbox-wrapper .tgl:checked + .tgl-btn:after {
  left: 50%;
}
.checkbox-wrapper .tgl-light + .tgl-btn {
  background: #b1b1b1;
  border-radius: 2em;
  padding: 2px;
  transition: all 0.4s ease;
}
.checkbox-wrapper .tgl-light + .tgl-btn:after {
  border-radius: 50%;
  background: #fff;
  transition: all 0.2s ease;
}
.checkbox-wrapper .tgl-light:checked + .tgl-btn {
  background: var(--primaryColor) !important;
}
.modal-dialog .modal-content {
  max-width: calc(100vw - 50px);
}
.modal-dialog .modal-header {
  justify-content: space-between;
}
.modal-dialog .modal-body {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  scrollbar-width: none;
}
.modal-dialog .fa-solid {
  font-size: 1.5rem !important;
  color: #fff !important;
}
.modal-dialog .btn-primary {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.modal-dialog .btn-cancel {
  background-color: #eee;
  color: #111;
}
.modal-dialog .btn {
  padding: 0.3rem 0.8rem !important;
}
.modal.fade {
  background: rgba(0, 0, 0, 0.2);
}
.modal.show {
  display: block;
}
.modal-header {
  background: var(--primaryColor);
  color: #fff;
}
#scroll-top-button {
  position: fixed;
  bottom: 6px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  right: 5px;
  align-items: center;
  display: flex;
  justify-content: center;
  background: #fff;
  box-shadow: 0 0 5px 2px #ddd;
}
#scroll-top-button .fa-arrow-up {
  font-size: 1.5rem !important;
}
ul.ai-tools-menu {
  display: inline;
  padding: 0px;
  margin: 0px;
}
ul.ai-tools-menu li {
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  cursor: pointer;
}
ul.ai-tools-menu li span {
  padding: 10px 10px 10px 3px;
  color: #222222;
  font-size: 0.9rem;
}
ul.ai-tools-menu li .fa {
  font-size: 0.9rem !important;
}
ul.ai-tools-menu li.active {
  color: var(--primaryColor);
}
ul.ai-tools-menu li.active i {
  color: var(--menuSelectColor) !important;
}
.custom-radios form {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.custom-radios label {
  display: inline-flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
}
.custom-radios label input {
  position: absolute;
  left: -9999px;
}
.custom-radios label input:checked + span {
  background-color: hsla(var(--primaryColor), 84%);
}
.custom-radios label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em var(--primaryColor);
}
.custom-radios label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 99em;
  transition: 0.25s ease;
  font-size: 0.9rem;
  font-weight: bold;
  color: #666;
}
.custom-radios label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em var(--primaryColor);
}
.radio-wrapper {
  padding-right: 1.5rem;
}
.right-sidebar {
  position: fixed;
  top: 0;
  right: -285px;
  width: 285px;
  height: 100%;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  transition: right 0.3s ease;
  z-index: 1000;
}
@media screen and (max-width: 767px) {
  .right-sidebar {
    width: 100%;
    max-width: 100%;
    right: -100%;
  }
}
.right-sidebar.open {
  right: 0;
}
@media screen and (max-width: 767px) {
  .right-sidebar.open {
    right: 0;
  }
}
.icon-btn {
  cursor: pointer;
  border: none;
  background: none;
  font-size: 24px;
  line-height: 1px;
  color: #fff;
}
.icon-btn:hover {
  color: #1571b9;
}
.close-btn {
  position: absolute;
  top: 0.3rem;
  right: 0.5rem;
  font-size: 1.7rem;
  font-weight: 600;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}
.close-btn:hover {
  color: #1571b9;
}
@media screen and (max-width: 767px) {
  .close-btn {
    font-size: 20px;
    top: 0.5rem;
    right: 0.5rem;
  }
}
.tab-list {
  list-style: none;
  display: flex;
  padding: 0;
}
.tab-list li {
  padding: 13px 10px;
  cursor: pointer;
  border: 1px solid transparent;
  border-bottom: none;
  width: 40px;
  text-align: center;
}
.tab-list li:hover {
  background-color: rgba(134, 183, 255, 0.9882352941);
  color: #fff !important;
}
.tab-list li:hover .fa,
.tab-list li:hover .fa-solid {
  color: var(--icondarkcolor) !important;
}
.tab-list li.active {
  border: 1px solid #1571b9;
  border-bottom: 1px solid #1571b9;
  background-color: #1571b9;
  color: #fff;
}
.tab-list li.active i.fa {
  color: #fff !important;
}
.tab-content {
  padding: 10px 0;
}
.tab-content .tab-view {
  width: 100%;
}
.tab-content .tab-view ul li:hover {
  background-color: rgba(21, 113, 185, 0.1607843137);
  color: #1571b9;
}
.tab-content .tab-view ul li label {
  white-space: nowrap;
  width: 78%;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.tab-content .tab-view ul li label .fa {
  line-height: 26px;
  margin-right: 10px;
}
.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #eee;
}
.history-item.odd {
  background-color: #f9f9f9;
}
.history-label {
  cursor: pointer;
  flex: 1;
}
.history-delete {
  color: #d9534f;
  cursor: pointer;
  margin-left: 10px;
}
.pin-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #e0e0e0;
}
.pin-item.odd {
  background-color: #f9f9f9;
}
.pin-label {
  cursor: pointer;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}
.pin-delete .pi-trash,
.history-delete .pi-trash {
  color: #c10909 !important;
}
.pin-delete,
.history-delete {
  cursor: pointer;
  padding-left: 10px;
  font-size: 1rem;
}
.file-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}
.file-item.odd {
  background-color: #f9f9f9;
}
.file-label {
  flex: 1;
  cursor: pointer;
  font-weight: 500;
  color: #333;
}
.file-date {
  font-size: 12px;
  color: #999;
}
.file-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-left: 10px;
}
.action-icon {
  color: #007bff;
  cursor: pointer;
  font-size: 1rem;
}
.action-icon:hover {
  color: #0056b3;
}
.audio-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px;
  border-bottom: 1px solid #eee;
  position: relative;
}
.audio-item.odd {
  background-color: #f9f9f9;
}
.audio-info {
  flex: 1;
  cursor: pointer;
}
.audio-label {
  font-weight: 500;
  color: #333;
}
.audio-date {
  font-size: 12px;
  color: #999;
}
.audio-player-wrapper {
  margin-left: 10px;
  position: relative;
}
.audio-play-icon {
  font-size: 20px;
  color: #007bff;
  cursor: pointer;
}
.audio-wrapper {
  position: absolute;
  right: 0;
  top: 30px;
  z-index: 10;
  background: #333;
  padding: 10px;
  border-radius: 8px;
}
.audio-wrapper.hide {
  display: none;
}
.close-audio {
  color: #fff;
  float: right;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 5px;
}
.audio-actions {
  margin-left: 10px;
}
.action-icon {
  font-size: 16px;
  color: #007bff;
  cursor: pointer;
}
.action-icon:hover {
  color: #0056b3;
}
.notification-list {
  margin-left: 0px !important;
  margin-top: 0px !important;
}
.notification-list li {
  margin-top: 0px !important;
}
.notification-list .file-item.active {
  background: #f4f4f4 !important;
}
.notification-list .file-item.active .file-label {
  color: var(--textsecondarycolor) !important;
}
.notification-list li {
  list-style: none !important;
}
.notification-list li:hover {
  background: #f0f0f0 !important;
}
.notification-list li:hover .fa,
.notification-list li:hover .fa-solid {
  color: var(--icondarkcolor) !important;
}
.notification-list label.file-label {
  width: 100% !important;
  max-width: 90% !important;
}
.pagination {
  padding-top: 5px !important;
}
.fa-microphone-slash.inactive {
  pointer-events: none !important;
}
.ai-assist-popup .doc-views-tabs {
  border-bottom-width: 0px !important;
}
.ai-assist-popup .pop-header {
  background: #253b80;
  color: #fff;
}
.ai-assist-popup .pop-header .fa-solid,
.ai-assist-popup .pop-header .fa {
  color: #fff !important;
}
.ai-assist-popup .card-content .file-item {
  border-bottom: 0px !important;
}
.ai-assist-popup .pop-content {
  height: calc(100vh - 200px);
  overflow-y: auto;
  width: 100%;
  scrollbar-width: 3px;
  color: var(--textsecondarycolor) !important;
}
.ai-assist-popup .pop-title {
  text-align: center;
  margin-left: 50px;
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ai-assist-popup .content-tab .level-left {
  width: 100% !important;
  border: 1px solid #81c2fb;
  border-radius: 5px;
  background: #fff !important;
  border-radius: 100px !important;
}
.ai-assist-popup .content-tab .level-left .level-item {
  width: 90%;
  justify-content: start;
}
.ai-assist-popup .content-tab .level-left .level-item.input-search-box .field,
.ai-assist-popup .content-tab .level-left .level-item.input-search-box .control,
.ai-assist-popup .content-tab .level-left .level-item.input-search-box .input {
  width: 100%;
}
.ai-assist-popup .list-wrapper.list-overflow {
  height: calc(100vh - 160px);
}
.ai-assist-popup .card {
  height: calc(100vh - 70px);
  overflow-y: auto;
}
.ai-assist-popup .pagination {
  position: absolute;
  width: 95%;
  bottom: 10px;
}
#suggestion-list {
  width: inherit;
  font-size: 0.9rem !important;
  border-radius: 5px;
  box-shadow:
    rgba(0, 0, 0, 0.09) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 2px 2px,
    rgba(0, 0, 0, 0.09) 0px 2px 4px,
    rgba(0, 0, 0, 0.09) 0px 2px 8px,
    rgba(0, 0, 0, 0.09) 0px 2px 5px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  z-index: 99;
  top: 43px;
}
#suggestion-list p {
  padding: 10px;
}
::ng-deep .p-multiselect {
  min-width: 15rem;
  width: 90px !important;
}
::ng-deep .p-multiselect .p-multiselect-header {
  display: none;
}
::ng-deep .p-inputwrapper.p-disabled {
  background: #eee !important;
}
::ng-deep .p-multiselect.p-inputwrapper {
  border: 1px solid #c8c8c8;
  padding: 5px;
}
::ng-deep .p-multiselect-items-wrapper {
  background: #fff;
  border: 1px solid #c8c8c8;
  padding: 5px;
}
::ng-deep .p-multiselect-items-wrapper .p-checkbox-box {
  border: 1px solid var(--primaryColor);
  width: 20px;
  height: 20px;
}
::ng-deep .p-inputwrapper.p-disabled {
  background: #eee !important;
}
::ng-deep .p-multiselect.p-inputwrapper {
  border: 1px solid #c8c8c8;
  padding: 5px;
}
::ng-deep .p-multiselect-items-wrapper {
  background: #fff;
  border: 1px solid #c8c8c8;
  padding: 5px;
}
::ng-deep .p-multiselect-items-wrapper .p-checkbox-box {
  border: 1px solid var(--primaryColor);
  width: 20px;
  height: 20px;
}
span.inactive ::ng-deep .p-dropdown {
  border: 1px solid red !important;
}
::ng-deep .p-dropdown {
  min-width: 15rem;
  width: 90px !important;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
}
::ng-deep .p-dropdown .p-dropdown-items {
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
}
::ng-deep .p-dropdown .p-dropdown-items li {
  padding: 5px;
}
::ng-deep .p-dropdown .p-dropdown-items li span {
  text-transform: capitalize;
}
::ng-deep .p-dropdown .p-dropdown-items li:hover {
  background: #f4f4f4 !important;
  color: #171717;
}
::ng-deep .p-dropdown .p-dropdown-items li[aria-selected=true] {
  background: #eee !important;
}
.category-dropdown-wrapper {
  display: flex;
  align-items: center;
  padding: 0 5px;
}
.dropdown-trigger {
  display: none;
}
.policy-upload .profile-img {
  margin: 5px;
  width: auto !important;
}
.policy-upload .profile-img .img-options {
  padding-top: 0px;
}
.policy-upload .modal-body {
  min-height: 315px;
}
.policy-upload .file-cta {
  background: var(--primaryColor);
}
.policy-upload .file-cta .pi {
  font-size: 1.3rem;
  color: #fff !important;
}
.radio-group {
  width: 250px !important;
}
.radio {
  margin: 0.5rem;
}
.radio input[type=radio] {
  position: absolute;
  opacity: 0;
}
.radio input[type=radio] + .radio-label:before {
  content: "";
  background: #f4f4f4;
  border-radius: 100%;
  border: 1px solid #f4f4f4;
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  position: relative;
  top: -0.1em;
  margin-right: 0.5em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}
.radio input[type=radio]:checked + .radio-label:before {
  background-color: #3197EE;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}
.radio input[type=radio]:focus + .radio-label:before {
  outline: none;
  border-color: #3197EE;
}
.radio input[type=radio]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: rgb(180.25, 180.25, 180.25);
  background: rgb(180.25, 180.25, 180.25);
}
.radio input[type=radio] + .radio-label:empty:before {
  margin-right: 0;
}
.icon {
  cursor: pointer;
}
.mobileBased-header-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
}
@media screen and (max-width: 480px) {
  .mobileBased-header-section {
    flex-direction: column;
    padding: 8px;
  }
}
.dropzone-upload-wrapper .dropzone {
  border: 2px dashed #ccc;
  border-radius: 0.5rem;
  text-align: center;
  padding: 2rem 1.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
  background: #fff;
  position: relative;
  margin-bottom: 1rem;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dropzone-upload-wrapper .dropzone.dragging {
  background: #f0f8ff;
  border-color: #1571b9;
}
.dropzone-upload-wrapper .dropzone.has-file {
  border-color: #ddd;
  background: #fafafa;
}
.dropzone-upload-wrapper .dropzone:hover:not(.has-file) {
  border-color: #999;
  background: #f9f9f9;
}
.dropzone-upload-wrapper .dropzone input[type=file] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.dropzone-upload-wrapper .dropzone .dropzone-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: #444;
  pointer-events: none;
}
.dropzone-upload-wrapper .dropzone .dropzone-label .icon {
  font-size: 2.5rem;
  color: #1571b9;
  margin-bottom: 0.25rem;
}
.dropzone-upload-wrapper .dropzone .dropzone-label .text {
  font-size: 0.95rem;
  color: #333;
}
.dropzone-upload-wrapper .dropzone .dropzone-label .text strong {
  display: block;
  margin-bottom: 0.25rem;
}
.dropzone-upload-wrapper .dropzone .dropzone-label small {
  color: #777;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}
.dropzone-upload-wrapper .selected-file-display {
  margin-top: 1rem;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: #fff;
  border-radius: 0.5rem;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .file-icon-wrapper {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .file-icon-wrapper i {
  font-size: 2rem;
  color: #1571b9;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .file-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .file-details .selected-file-name {
  font-weight: 400;
  color: #333;
  margin: 0;
  word-break: break-word;
  font-size: 0.95rem;
  line-height: 1.4;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .file-details .file-size-text {
  color: #666;
  font-size: 0.875rem;
  margin: 0;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .delete-btn {
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: #999;
  cursor: pointer;
  font-size: 1.25rem;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s;
  width: 32px;
  height: 32px;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .delete-btn:hover {
  color: #666;
  background: #f5f5f5;
}
/*# sourceMappingURL=ai-assist.component.css.map */
